<ion-item [lines]="lines">
  <ion-label>
    <p *ngFor="let perc of rows">
      <ion-skeleton-text animated [style.width.%]="perc"></ion-skeleton-text>
    </p>
  </ion-label>
</ion-item>